module.exports = __webpack_public_path__ + "media/images/m-movie-8403c23a.png";